export enum WirePurpose {
  OwnNLive = 'OwnNLive',
  HldHmIncm = 'HldHmIncm',
  OwnNRented = 'OwnNRented',
  OwnNRentST = 'OwnNRentST',
  Unspecified = '',
}

export enum WireBuildingCoverSIOption {
  Estimated = 'Estimated',
  Manual = 'Manual',
  Unspecified = '',
}

export type WireBuilding = {
  isAboveGround?: boolean;
  isMultiStory: boolean;
  isUnderStrata: boolean;
  numberOfRooms: number;
  type: string;
  roof?: string;
  wall?: string;
  year?: string;
  level: string;
  hasCOO: boolean;
};

export type WireBuildingCoverSI = {
  selected: WireBuildingCoverSIOption;
  estimated: number;
};

export type WireSecurity = {
  code: string;
  description?: string;
};

export type WireBusinessSpecific = {
  toStoreCash: boolean;
  toStoreStock: boolean;
  toStoreHazardGoods: boolean;
  numberOfVisits: string;
  businessType: string;
};

export type WireMortgageLender = {
  popular: string;
  other?: string;
};

export type WireAsset = {
  addressRefId: string;
  building?: WireBuilding;
  buildingCoverSI?: WireBuildingCoverSI;
  coverageRefIds: string[];
  hasContentsItems?: boolean;
  hasAddSecurity?: boolean;
  id: string;
  partyRefIds?: string[];
  isOwned: boolean;
  purpose: WirePurpose;
  securities?: WireSecurity[];
  isUsedForBusiness: boolean;
  businessSpecific?: WireBusinessSpecific;
  isHeritageListed?: boolean;
  isRewiredOrReplumbed?: boolean;
  isMaintained?: boolean;
  hasMaxUnrelatedOccupants?: boolean;
  isUnderConstruction?: boolean;
  hasPlannedConstruction?: boolean;
  isOver5Acres?: boolean;
  isUnoccupied?: boolean;
  mortgageLender?: WireMortgageLender;
  rentalAgreement?: boolean;
};
